import "./App.css";
import AudioRecorder from "./audio-recorder";
import Card from "./audio-recorder/components/card";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <Card>
          <span style={{ fontSize: "132px" }}>🎤</span>
          <br />
          <AudioRecorder />
        </Card>
      </div>
    </div>
  );
}

export default App;
